import { Component, inject, input } from '@angular/core';
import { Solution } from '../../models/solutions.model';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-card-solution',
  imports: [CommonModule, NgOptimizedImage, RouterModule],
  templateUrl: './card-solution.component.html',
  styleUrl: './card-solution.component.scss',
})
export class CardSolutionComponent {
  public solution = input.required<Solution>();
  public showApps = input<boolean>();
  private router = inject(Router);

  goTo(slug: string): void {
    this.router.navigate(['/soluciones-digitales/' + slug]);
  }
}
